/* istanbul ignore next */
const getCollegeService = () => window.collegeService;

export default getCollegeService;
